<template>
  <div class="cls-table table-component">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields" show-toggle-columns
                   :search="tableData.search"
                   :enable-simple-search="false" @paramsChanged="getTableData"
                   filter-toggle-string="cls-table"
                   :extra-data="extraData" @update-toggle-columns="updateToggleColumns"
                   @on-column-save="updateToggleColumns">

      <template v-slot:search-form-placeholder>
        <search-collapse table-id="cls-table">
          <cls-search :exclude-search-fields="excludeSearchFields"/>
        </search-collapse>
      </template>

      <template slot="cell(title)" slot-scope="{item}">
        {{ item.title }}
        <action-buttons :view="false"
                        @editClick="onEditClick(item)"
                        @deleteClick="onRemoveClick(item)"/>
      </template>

      <template slot="cell(created_at)" slot-scope="{item}">
        {{ item.created_at | toDate }} by {{ item.created_by.display_name }}
      </template>

      <template slot="cell(updated_at)" slot-scope="{item}">
        {{ item.updated_at | toDate }} by {{ item.updated_by.display_name }}
      </template>

      <template slot="cell(levels)" slot-scope="{item}">
        {{ item.data ? item.data.length : 0 }}
      </template>

    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../../core/components/ams-table/ArtisioTable";
  import {
    CLS_TABLE_NAME,
    SOURCE_CLS_TABLE
  } from "../../constants";
  import ActionButtons from "../../../core/components/ams-table/ActionButtons";
  import SearchCollapse from "../../../core/components/search-collapse/SearchCollapse";
  import _ from "lodash";
  import ClsSearch from "@/modules/setup/cls/ClsSearch";

  const {mapState, mapActions} = createNamespacedHelpers('cls');

  export default {
    name: "ClsTable",
    components: {ClsSearch, SearchCollapse, ActionButtons, ArtisioTable},
    props: {
      hideActions: {
        type: Boolean,
        default: false
      },
      excludeSearchFields: {
        type: Array,
        default: () => []
      },
      excludeColumns: {
        type: Array,
        default: () => []
      },
    },
    data: () => {
      return {
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
        toggleColumns: state => state.tableData[state.tableSource].toggleColumns,
        tableSource: state => state.tableSource,
      }),
      tableFields() {
        return _.cloneDeep(this.toggleColumns.fields)
          .filter(field => !this.excludeColumns.includes(field.key) && field.isVisible)
      },
      extraData() {
        return {
          ...this.toggleColumns,
          excludeColumns: this.excludeColumns,
          tableName: `${CLS_TABLE_NAME}.${this.tableSource}`,
        }
      }
    },
    methods: {
      ...mapActions(['getTableData', 'showModal', 'removeCustomLotSequence', 'getModalObject', 'updateToggleColumns']),
      onEditClick(item) {
        this.showModal()
        this.getModalObject({uuid: item.uuid, source: SOURCE_CLS_TABLE})
      },
      async onRemoveClick(cls) {
        this.$confirm(
          this.$i18n.t("Are you sure you want to delete following custom lot sequence?"),
          this.$i18n.t('Custom lot sequence was successfully deleted'),
          this.removeCustomLotSequence,
          cls
        );
      }
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>

</style>

